import { Component, OnDestroy, OnInit } from '@angular/core';
import { GopherService } from '../gopher.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { NgChartjsService } from 'ng-chartjs';
import { GopherChartConfig } from '@app/_constants/gopher-results-line-chart';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.less']
})
export class DetailsComponent implements OnInit, OnDestroy {

  constructor(private gopherService: GopherService, private toastr: ToastrService,
    private route: ActivatedRoute, private router: Router, private ChartService: NgChartjsService) { }

  currUser;
  attackDetails: any = {};
  interval;
  // Graph veriables
  data: number[] = [];
  labels: string[] = [];
  lineChartType = 'line';
  lineChartOptions: any = GopherChartConfig;
  colors: any = ['#87ceeb'];

  ngOnInit() {
    this.currUser = JSON.parse(localStorage.getItem('user'));
    if (!this.currUser.gopherAdmin) {
      this.router.navigate(['home']);
    }
    this.getAttackDetails(this.route.snapshot.paramMap.get('id'));
  }

  getAttackDetails(id) {
    this.gopherService.getAttackDetails(id).pipe().subscribe(data => {
      if (data.code === 200) {
        this.attackDetails = data.response;
        this.setGraph(data.response.results);
        clearInterval(this.interval);
        if (!data.response.isCompleted) {
          this.interval = setInterval(() => {  
          this.getAttackDetails(id);
      }, 5000);
        } else {
          clearInterval(this.interval);
        }
      } else {
        this.toastr.error(data.response);
      }
    });
  }

  setGraph(results) {
    results.forEach(element => {
      let startTime = element.startTime.split(' ')[1];
      this.data = [...this.data, element.usage];
      this.labels = [...this.labels, startTime];
    });
  }

  haltAttack(id) {
    this.gopherService.abort(id).pipe().subscribe(data => {
      if (data.code === 200) {
        this.getAttackDetails(id);
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  ngOnDestroy() {
    clearInterval(this.interval)
  }

}
